import { Pipe, PipeTransform, inject } from '@angular/core';
import { TableConstructUIService } from '../services/table-construct.service';
import { TableHeaderCellDefUIDirective } from '../directives/table-header-cell-def.directive';

@Pipe({ name: 'getHeaderCell' })
export class TableGetHeaderCellPipe<DataType> implements PipeTransform {
  private tableService = inject<TableConstructUIService<DataType>>(TableConstructUIService);

  transform(columnName: string): TableHeaderCellDefUIDirective | null {
    return this.tableService.getHeaderCell(columnName);
  }
}
